<template>
  <div id="vs4Preview" class="vs4-preview" v-drag @click.stop>
    <div class="vs4-top">
      <span class="title float-left">{{videoInfo.title ? videoInfo.title : '视频'}}</span>
      <i class="iconfont iconclose float-right" @click.stop="_vs4Close"></i>
    </div>
    <div
      class="vs4-content"
      v-loading="videoInfo.loading"
      element-loading-text="视频正在跑步加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="grba(255, 255, 255, 0.5)"
    >
      <h5-video
        v-if="refresh"
        class="h5-video"
        ref="videoWrapper"
        :isTrailer="videoInfo.isTrailer"
        :trailerDuration="videoInfo.trailerDuration"
        :resourceId="videoInfo.resourceId"
        :videoUrl="videoInfo.videoUrl"
        :coverUrl="videoInfo.coverUrl"
        :enValue="videoInfo.enValue"
        :zhValue="videoInfo.zhValue"
        :enAndzhValue="videoInfo.enAndzhValue"
        :tValue="videoInfo.tValue"
        :hadLogo="videoInfo.hadLogo"
        :level="videoInfo.level ? videoInfo.level : (videoInfo.levelId ? videoInfo.levelId: 2)"
        :subject="videoInfo.subject ? videoInfo.subject : (videoInfo.subjectId ? videoInfo.subjectId: 0)"
        :fromPopUp="true"
      ></h5-video>
    </div>
  </div>
</template>
<script>
import H5Video from "components/h5video";
export default {
  components: {
    H5Video
  },
  props: {
    videoInfo: {
      type: Object
    }
  },
  data() {
    return {
      refresh: true,
    };
  },
  watch: {
    videoInfo: {
      deep: true,
      immediate: true,
      handler(obj, oldVal) {
        console.log(obj);
        if(obj && oldVal && obj.videoUrl === oldVal.videoUrl) {
          this.refresh = false;
          setTimeout(() => {
            this.refresh = true;
          }, 50);
        }
      }
    }
  },
  directives: {
    drag: {
      // 指令的定义
      inserted: function(el) {
        el.onmousedown = function(e) {
          let _class = $(e.target).attr("class");
          if (
            _class.indexOf("vs4-top") === -1 &&
            _class.indexOf("title") === -1
          ) {
            return;
          }
          let moveEle = $("#vs4Preview"),
            x = 0,
            y = 0,
            nx = 0,
            ny = 0,
            nl = 0,
            nt = 0,
            l = 0,
            t = 0,
            ml = 0,
            mt = 0,
            isDown = false;
          //获取x坐标和y坐标
          x = e.clientX;
          y = e.clientY;
          //获取左部和顶部的偏移量
          // l = moveEle.offset().left;
          // t = moveEle.offset().top;
          l = moveEle[0].offsetLeft;
          t = moveEle[0].offsetTop;

          ml = moveEle.css("marginLeft");
          ml = ml.replace("px", "");
          mt = moveEle.css("marginTop");
          mt = mt.replace("px", "");
          document.onmousemove = function(e) {
            //获取x和y
            nx = e.clientX;
            ny = e.clientY;
            //计算移动后的左偏移量和顶部的偏移量
            nl = nx - (x - l) - ml;
            nt = ny - (y - t) - mt;

            moveEle.css({ left: nl + "px", top: nt + "px" });
          };
          document.onmouseup = function(e) {
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
      }
    }
  },
  methods: {
    /**
     * vs4关闭预览
     * **/
    _vs4Close(data) {
      this.$refs.videoWrapper._videoPause();
      if (data === "switch") {
        return;
      }
      this.$emit("handleClose");
    }
  }
};
</script>
<style lang="less" scoped>
.vs4-preview {
  width: 800px;
  height: 500px;
  position: fixed;
  left: 50%;
  top: 50%;
  margin-left: -400px;
  margin-top: -250px;
  box-shadow: 0 0px 40px 0 rgba(0, 46, 54, 0.2);
  z-index: 999;

  .vs4-top {
    width: 100%;
    height: 50px;
    line-height: 50px;
    background-color: #03B2B2;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    cursor: move;
    padding: 0 20px;

    .title {
      max-width: 70%;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 18px;
      float: left;
      color: #fff;
    }

    .iconclose {
      cursor: pointer;
      font-size: 20px;
      color: #fff;

      &:hover {
        text-shadow: 0 0 2px #fff;
      }
    }
  }

  .vs4-content {
    width: 100%;
    height: 450px;
    margin-top: 50px;
    background-color: #fff;
    // background-image: linear-gradient(0deg, rgb(141, 141, 141) 0%, rgb(0, 179, 138) 98%);
    // background-image: linear-gradient(0deg, rgb(141, 141, 141) 0%, rgba(143, 148, 147, 1) 98%);
  }
}
</style>